import { useAuth0 } from "@auth0/auth0-react";
import Container from "@mui/material/Container";
import { useEffect, useState } from "react";

import API_Calls_Dashboard from "@/api/calls/API_Calls_Dashboard";
import Dashboard from "@/components/membership/Dashboard/Dashboard";
import Notifications from "@/components/Notifications/Notifications";
import { DASHBOARD_REFRESH } from "@/constants/dashboard";

function DashboardContainer() {
  const [dashboardData, setDashboardData] = useState(null);
  const [notification, setNotification] = useState({});
  const { getDashboard } = API_Calls_Dashboard();
  const { user } = useAuth0();

  useEffect(() => {
    getDashboardData();
    // getDashboardData is an inline function recreated every render;
    // intentionally fire only on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const interval = setInterval(() => getDashboardData(), DASHBOARD_REFRESH);
    return () => {
      clearInterval(interval);
    };
    // getDashboardData is an inline function recreated every render;
    // intentionally start the refresh interval only on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDashboardData = async () => {
    const dashboardDataResponse = await getDashboard(user.org_name);
    if (dashboardDataResponse.error) {
      setNotification({
        message: "Dashboard data unavailable at this time",
        severity: "error",
        duration: null,
      });
      setDashboardData({
        updated: null,
        out_of_date: [],
        files: [],
      });
    } else {
      setDashboardData(dashboardDataResponse.data);
    }
  };

  return (
    <>
      <Container sx={{ maxWidth: "1300px !important" }}>
        {dashboardData && <Dashboard dashboardData={dashboardData} />}
      </Container>
      {!!Object.keys(notification).length && (
        <Notifications
          notification={notification}
          setNotification={setNotification}
        />
      )}
    </>
  );
}

export default DashboardContainer;
